import Box, { BoxProps } from '@mui/material/Box';

import { useResponsive } from 'src/hooks/use-responsive';

import { useGetProfileQuery } from 'src/graphql/generated';

import { useSettingsContext } from 'src/components/settings';
import TermPolicyDialog from 'src/components/custom-dialog/term-policy-dialog';

import { NAV, HEADER } from '../config-layout';
import DisconnectedStoreComponent from '../common/disconnectedStore';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({
  children,
  sx,
  fullScreen = false,
  ...other
}: BoxProps & { fullScreen?: boolean }) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const { data: profileRequestResponse, loading } = useGetProfileQuery();

  const content = (
    <>
      {!loading && !profileRequestResponse?.me?.acceptedTerm && <TermPolicyDialog />}
      {!loading &&
        (profileRequestResponse?.me?.connectedStore?.isActive ? (
          children
        ) : (
          <DisconnectedStoreComponent />
        ))}
    </>
  );

  if (fullScreen) {
    return (
      <Box
        component="main"
        sx={{
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          ...sx,
        }}
        {...other}
      >
        {content}
      </Box>
    );
  }

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: `${HEADER.H_MOBILE + 24}px`,
          pb: 10,
          ...(lgUp && {
            pt: `${HEADER.H_MOBILE * 2 + 40}px`,
            pb: 15,
          }),
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(lgUp && {
          px: 2,
          py: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {content}
    </Box>
  );
}
